import { render, staticRenderFns } from "./Stray.vue?vue&type=template&id=062ebbbc&scoped=true&"
import script from "./Stray.vue?vue&type=script&lang=js&"
export * from "./Stray.vue?vue&type=script&lang=js&"
import style0 from "./Stray.vue?vue&type=style&index=0&id=062ebbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ebbbc",
  null
  
)

export default component.exports